import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  loading: false,
  dataSolicitation: [],
  totalCount: 0,
};

export const loadListSolicitation = createAsyncThunk(
  'spotListSolicitation/loadListSolicitation',
  async ({ status, isPMO, isLead, headers }) => {
    const response = await redemptionsApiClient.get(
      `redemption/GetByParticipant?pageSize=500${
        isLead ? '&isLeadership=true' : ''
      }&isManager=${isPMO || isLead}${
        status !== '' ? `&status=${status}` : ''
      }`,
      {
        headers: headers,
      }
    );
    const { data } = response;
    return data;
  }
);

const spotListSolicitation = createSlice({
  name: 'spotListSolicitation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadListSolicitation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loadListSolicitation.fulfilled, (state, action) => {
      state.loading = false;
      state.dataSolicitation = action.payload.data;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(loadListSolicitation.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default spotListSolicitation.reducer;
